export default __webpack_public_path__ + "static/media/loading.51faa810.png";